module.exports = __webpack_public_path__ + "static/media/mp3.c5a0b9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/mp3.png
// module id = 2563
// module chunks = 0